import React, { useMemo } from "react";
import styled from "@emotion/styled";

import StatTypes from "types/StatTypes";

import Paper from "@mui/material/Paper";

import StatsComponent from "components/StatsComponent";
import StatsContainer from "components/StatsContainer";
import Placeholder from "./Placeholder";

// @ts-ignore
const Container = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "numberOfSection",
})`
  display: flex;
  flexdirection: row;
  fontfamily: "Source Sans Pro", sans-serif;
  flex: ${(props: { numberOfSection: number }) =>
    `${props.numberOfSection} 1 0`};
  max-width: ${(props: { numberOfSection: number }) =>
    `${props.numberOfSection * 168}px`};
`;

type Props = {
  stats: StatTypes[];
  initialized: boolean;
  containerStyles: {};
  numberOfSection: number;
};

function StatsRow({
  stats,
  initialized,
  containerStyles,
  numberOfSection,
}: Props): JSX.Element {
  const numberOfElements = useMemo(() => {
    return 4 - (stats?.length || 0);
  }, [stats]);

  if (!initialized) {
    return <Placeholder height="120px" delay={0} />;
  }
  if (!stats || !stats?.length) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", flex: 1, ...containerStyles }}>
      <Container numberOfSection={numberOfSection}>
        {stats?.map((data, index) => (
          <StatsComponent
            data={data}
            key={index}
            numberOfSection={numberOfSection}
          />
        ))}
      </Container>

      {Array(numberOfElements)
        .fill(null)
        .map((i, key) => (
          <StatsContainer
            key={key}
            style={{
              visibility: "hidden",
              flex: 1,
              padding: "0px",
              margin: "0px",
            }}
          />
        ))}
    </div>
  );
}

export default StatsRow;
